import type { ReactNode } from "react";

import style from "./style.module.css";

interface H1Props {
  className?: string;
  children: ReactNode;
}

const H1 = ({ children, className }: H1Props) => {
  return <div className={`${style.h1} ${className}`}>{children}</div>;
};

export default H1;
